import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const getOnlineOrderRecalcData = createSelector(onlineOrderState, (onlineOrder) => onlineOrder.recalculateRequest);
